import { apiSlice } from "./apiSlice";
import config from "../../config.json";

export const usersApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getRegisteredUsers: builder.query({
      query: ({ pageSize, pageIndex, type }) =>
        (config.GetRegisteredUsers || "") + pageSize + "&pageNumber=" + pageIndex + "&type=" + type,
      providesTags: ["User"],
    }),
    getEmailConfig: builder.query({
      query: () => config.GetEmailSetup || "",
      providesTags: ["EmailConfig"],
    }),
    getSecQuestions: builder.query({
      query: (type) => (config.GetCodemanager || "") + type,
      providesTags: ["SecurityQuestions"],
    }),
    getAllEmailHistory: builder.query({
      query: (id) => (config.GetAllEmails || "") + id,
      providesTags: ["EmailHistory"],
    }),
    sendEmailMessage: builder.mutation({
      query: (id) => ({
        url: (config.SendMailMessage || "") + id,
        method: "GET",
      }),
      invalidatesTags: ["EmailHistory"],
    }),
    deleteEmailMessage: builder.mutation({
      query: (id) => ({
        url: (config.DeleteMailMessage || "") + id,
        method: "GET",
      }),
      invalidatesTags: ["EmailHistory"],
    }),
    updateEmailConfig: builder.mutation({
      query: (data) => ({
        url: config.SaveEmailSetup || "",
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["EmailConfig"],
    }),
    addNewEmailMessage: builder.mutation({
      query: (data) => ({
        url: config.AddNewEmail || "",
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["EmailHistory"],
    }),
    updateEmailMessage: builder.mutation({
      query: (data) => ({
        url: config.UpdateMailMessage || "",
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["EmailHistory"],
    }),
    getRegisteredUsersByFilter: builder.mutation({
      query: (data) => ({
        url: config.GetRegisteredUsersByFilter || "",
        method: "POST",
        body: data,
      }),
    }),
    addUserSecurityQuestion: builder.mutation({
      query: (data) => ({
        url: config.AddSecurityQuestion || "",
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["SecurityQuestions"],
    }),
    getUserAccessLogHistory: builder.query({
      query: ({ id, type }) =>
        (config.GetAccessRightHistory || "") + id + "&type=" + type,
      providesTags: ["AccessHistory"],
    }),
    updateUserActiveDeactive: builder.mutation({
      query: (data) => ({
        url: config.SetActivateDeactivate || "",
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["User", "AccessHistory"],
    }),
  }),
});

export const {
  useLazyGetRegisteredUsersQuery,
  useLazyGetEmailConfigQuery,
  useLazyGetSecQuestionsQuery,
  useLazyGetAllEmailHistoryQuery,
  useSendEmailMessageMutation,
  useDeleteEmailMessageMutation,
  useUpdateEmailConfigMutation,
  useAddNewEmailMessageMutation,
  useUpdateEmailMessageMutation,
  useGetRegisteredUsersByFilterMutation,
  useAddUserSecurityQuestionMutation,
  useGetUserAccessLogHistoryQuery,
  useLazyGetUserAccessLogHistoryQuery,
  useUpdateUserActiveDeactiveMutation,
} = usersApiSlice;
